module.exports = __webpack_public_path__ + "static/media/create_profile_alternative.e453e3f9.svg";